export default "__VITE_ASSET__BSld1W75__"